import {CircleButton, Popover} from "Ncontracts.Common.UI";
import PropTypes from 'prop-types';
import React, {Component} from "react";
import {CSVLink} from "react-csv";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {ReactSVG} from "react-svg";
import {getCommunicationsReportData} from "../../actions/communications/communicationsAction";
import isEmpty from "../../helpers/isEmpty";
import {imageCdnUrls} from "../common/ImageCdnUrls";

class CommunicationReportsMenu extends Component {

    static propTypes = {
        detailedReportData: PropTypes.array,
        fetchReportData: PropTypes.func,
        summaryReportData: PropTypes.array
    };

    constructor(props, context) {
        super(props, context);
        this.props.fetchReportData();

        this.state = { showPopover: false };
    }

    getSummaryReportHeaders = () => {
        let headers = [
            { label: "Title (subject)", key: "commTitle" },
            { label: "Event", key: "event" },
            { label: "Event Type", key: "eventType" },
            { label: "Total Contacts", key: "recipientCount" },
            { label: "Email (y/n)", key: "emailSent" },
            { label: "Text (y/n)", key: "smsSent" },
            { label: "Voice (y/n)", key: "voiceSent" },
            { label: "Creation (last edit)", key: "dateCreatedString" },
            { label: "Sent", key: "sentDateString" },
            { label: "Message", key: "message" },
            { label: "Poll (y/n)", key: "includesPoll" },
            { label: "Poll question", key: "pollQuestion" },
            { label: "Poll response unanswered", key: "pollNoResponseCount" },
        ];

        for (let i = 1; i < 7; i++) {
            headers.push({label: `Poll response ${i} text`, key: `pollOptionText_${i}`});
            headers.push({label: `Poll response ${i} #`, key: `pollOptionResponseCount_${i}`});
        }

        return headers;
    };

    getDetailedReportHeaders = () => {
        let headers = [
            { label: "Title (subject)", key: "commTitle" },
            { label: "Event", key: "event" },
            { label: "Event Type", key: "eventType" },
            { label: "Email (y/n)", key: "emailSent" },
            { label: "Text (y/n)", key: "smsSent" },
            { label: "Voice (y/n)", key: "voiceSent" },
            { label: "Creation (last edit)", key: "dateCreatedString" },
            { label: "Sent", key: "sentDateString" },
            { label: "Message", key: "message" },
            { label: "First Name", key: "firstName" },
            { label: "Last Name", key: "lastName" },
            { label: "Person's Title", key: "title" },
            { label: "Work Phone", key: "workphone" },
            { label: "Home Phone", key: "homephone" },
            { label: "Cell Phone", key: "cellphone" },
            { label: "Personal Email", key: "personalEmail" },
            { label: "Work Email", key: "workEmail" },
            { label: "Poll (y/n)", key: "includesPoll" },
            { label: "Poll question", key: "pollQuestion" },
            { label: "Poll response unanswered", key: "noResponse" },
        ];

        for (let i = 1; i < 7; i++) {
            headers.push({label: `Poll response ${i} text`, key: `pollOptionText_${i}`});
            headers.push({label: `Poll response ${i} #`, key: `pollOptionResponse_${i}`});
        }

        return headers;
    };

    render() {
        const {detailedReportData, summaryReportData} = this.props;

        return (
            <div className="page-header-buttons">
                <CircleButton className="popover-container" isOpen={this.state.showPopover}
                              onClick={() => this.setState({...this.state, showPopover: !this.state.showPopover})}>
                    <ReactSVG className="download-svg" src={imageCdnUrls.download}/>
                    <Popover showPopover={this.state.showPopover} caretPosition="top-right" slideDirection="slide-down"
                             leftOffset="-165px" bottomOffset="null">
                        <div className="popover-menu">
                            <div className="menu-item">
                                {
                                    isEmpty(summaryReportData) ? <span>All Communications Directory (CSV)</span> :
                                    <CSVLink data={summaryReportData} headers={this.getSummaryReportHeaders()} filename="CommunicationsSummaryReport.csv">
                                        All Communications Directory (CSV)
                                    </CSVLink>
                                }
                            </div>
                            <div className="menu-item">
                                {
                                    isEmpty(detailedReportData) ? <span>All Communications Detailed Report (CSV)</span> :
                                    <CSVLink data={detailedReportData} headers={this.getDetailedReportHeaders()} filename="DetailedCommunicationsReport.csv">
                                        All Communications Detailed Report (CSV)
                                    </CSVLink>
                                }
                            </div>
                        </div>
                    </Popover>
                </CircleButton>
            </div>);
    }
}

const mapStateToProps = state => ({
    detailedReportData: state.communications.detailedReportData,
    summaryReportData: state.communications.summaryReportData,
});

const mapDispatchToProps = dispatch => ({
    fetchReportData: () => dispatch(getCommunicationsReportData()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CommunicationReportsMenu));
